export default __webpack_public_path__ + "static/media/Brassarts of the Ragereaver.9e0edf47.jpg";